<div class="row settings-license-types">
    <div class="col-sm-12">
        <div class="box-content">
            <div class="box">
                <div class="box-header">
                    <h2>
                        <i class="fa fa-certificate"></i>
                        <span class="break"></span>
                        License Types
                    </h2>
                    <span
                        kno2Popover="License types enforce compatibility rules for devices and other connectors which makes it possible to ensure a license purchased for one type of device or connector is not applied to a different type of device or connector."
                        popoverPlacement="auto">
                        <i class="fa fa-info-circle box-info"></i>
                    </span>

                    <div class="box-icon">
                        <button
                            (click)="edit()"
                            data-bs-toggle="tooltip"
                            alt="Create"
                            title="Create">
                            <i class="fa fa-plus-circle"></i>
                        </button>
                    </div>
                </div>

                <div class="box-content">
                    <div class="d-flex justify-content-between">
                        <kno2-pagination-page-size (pageSizeChange)="onPageSizeChange({ pageSize: $event.pageSize })" />
                        <kno2-pagination-search (searchChange)="queryOptions.change($event)" />
                    </div>

                    <kno2-table
                        [columns]="columns()"
                        [data]="adminLicenseTypes()?.items"
                        [rowActions]="rowActionsTemplate"
                        (onSort)="sortChange($event)">
                        <ng-template
                            #compatibleConnectorsTemplate
                            let-adminLicenseType>
                            <kno2-multi-value-display
                                [values]="adminLicenseType.apps | pluck: 'name'"
                                [showCount]="5" />
                        </ng-template>

                        <ng-template
                            #rowActionsTemplate
                            let-adminLicenseType>
                            <button
                                (click)="edit(adminLicenseType)"
                                class="btn"
                                alt="Edit"
                                data-bs-toggle="tooltip"
                                title="Edit">
                                <i class="fa fa-pencil"></i>
                            </button>
                            <button
                                (click)="deleteAdminLicenseType(adminLicenseType)"
                                class="btn ms-1"
                                alt="Delete"
                                data-bs-toggle="tooltip"
                                title="Delete">
                                <i class="fa fa-trash"></i>
                            </button>
                        </ng-template>
                    </kno2-table>

                    <div class="d-flex justify-content-end">
                        <kno2-pagination
                            [collectionSize]="adminLicenseTypes()?.totalCount"
                            [page]="queryOptions.query().page"
                            [pageSize]="queryOptions.query().size"
                            (pageChange)="queryOptions.change({ page: $event })" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
